var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Inline } from "syf-component-library/ui/spacing";
import { PhoneTitle, RowInset, RowPhone, RowSubItem } from "./subcomponents";
import getPhoneValues from "../../../helpers/getPhoneValues";
import ProfileRow from "../ProfileRow";
import getTranslation from "../../../strings/getTranslations";
var PhoneNumbers = function (_a) {
    var _b;
    var data = _a.data;
    var t = getTranslation().t;
    var numbers = ((_b = data === null || data === void 0 ? void 0 : data.profile) === null || _b === void 0 ? void 0 : _b.phone) || [];
    var fieldValues = getPhoneValues(numbers);
    return (_jsx(ProfileRow, __assign({ title: t("labels.phone"), titleSpacingSize: "large", flip: "horizontal" }, { children: _jsxs(RowPhone, __assign({ "data-private": true }, { children: [_jsxs(RowInset, __assign({ top: "medium", bottom: "medium" }, { children: [_jsx(RowSubItem, { children: t("labels.mobile") }), _jsx(Inline, { size: "xlarge" }), _jsx(PhoneTitle, __assign({ "data-cy": "mobilePhone" }, { children: fieldValues.MOBILE.toString() }))] })), _jsxs(RowInset, __assign({ top: "medium", bottom: "medium" }, { children: [_jsx(RowSubItem, { children: t("labels.home") }), _jsx(Inline, { size: "xlarge" }), _jsx(PhoneTitle, { children: fieldValues.HOME.toString() })] })), _jsxs(RowInset, __assign({ top: "medium", bottom: "medium" }, { children: [_jsx(RowSubItem, { children: t("labels.business") }), _jsx(Inline, { size: "xlarge" }), _jsx(PhoneTitle, { children: fieldValues.BUSINESS.toString() })] }))] })) })));
};
export default PhoneNumbers;
